import React from 'react';
import {Logo} from './../../components/common/Logo/Logo.js';
import {connect} from 'react-redux';
import {OnAlreadyLinkedPageLoad,OnSetAsPreferred,OnNotNow} from './../../components/SiteCat/SiteCat';
import {getMerchantData,onUserCancel,setPreferedUrl} from './../../constants/merchantData';

class AccountAlreadyLinked extends React.Component{
  constructor() {
    super();
    this.state = {
      merchantName:"",
      authCode:""
    };
  }

  componentWillMount = () =>{
    this.setState({
      merchantName : this.props.linkedposts.merchant,
      authCode : this.props.linkedposts.authcode
    });
  }

  componentDidMount() {
    OnAlreadyLinkedPageLoad(this.state.merchantName);
    const setAsPrefered = this.props.linkedposts.setAsPrefferdUrl
    const cancelUrlData = this.props.linkedposts.cancelUrl ;
    this.setState({
      setAsPrefered,
      cancelUrlData
    });
  }

  handleSetAsPreffered = event =>{
    OnSetAsPreferred(this.state.merchantName);
   let data = {
    merchantName: this.state.merchantName,
    setAsPrefered: this.state.setAsPrefered,
    authCode: this.state.authCode
   }
   setPreferedUrl(data);
 }

 handleCancel = event => {
  OnNotNow(this.state.merchantName);
  let data = {
    merchantName: this.state.merchantName,
    cancelUrlData: this.state.cancelUrlData,
    authCode: this.state.authCode 
  }
  onUserCancel(data);
}

  render() {
    const merchantData = getMerchantData(this.state.merchantName)
    return(
      <React.Fragment>
        <div className="row">
            <div className="common-header-logo alreadylink-blk-head col-xs-12 col-sm-8 col-md-7 col-lg-3 col-md-offset-4 col-lg-offset-4 col-sm-offset-2">
               <div class="paypal-logo">
                  <Logo merchantName ={this.state.merchantName}/>
               </div>
            </div>
        </div>

         <div className="row">
           <div className="alreadylink-blk col-xs-12 col-sm-8 col-md-7 col-lg-3 col-md-offset-2 col-lg-offset-4 col-sm-offset-2">
             <div class="alreadylink-header">{merchantData.AccountAlreadyLinked.HEADER}</div>
             <div className="row alreadylinked-section">
               <div class="alreadylink-content  col-xs-10 col-sm-10 col-md-10 col-lg-10">{merchantData.AccountAlreadyLinked.MESSAGE}</div>
              </div>
           </div>
         </div>

        <div className="row">
            <div className="alreadylink-blk col-xs-12 col-sm-8 col-md-7 col-lg-3 col-md-offset-2 col-lg-offset-4 col-sm-offset-2">
            <div className="row alreadylink-btn">
             <button onClick={this.handleSetAsPreffered}>{merchantData.AccountAlreadyLinked.BUTTON}</button>
            </div>
            <div className="row multicard-cancel">
            <button class="changebtnproperty" onClick={this.handleCancel}>{merchantData.AccountAlreadyLinked.LINK}</button>
            </div>
            </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    linkedposts: state
  }
}

export default connect(mapStateToProps)(AccountAlreadyLinked);